import { useFeatureFlag } from '../../_hooks/useFeatureFlag';
import { Feature } from '../../CommonSelectors/CommonArea.types';

export const useTabLabels = () => {
  const showActivityDetails = useFeatureFlag(Feature.ActivityDetails);

  return {
    summary: 'Summary',
    allocation: 'Allocation',
    performance: 'Performance',
    activity: showActivityDetails ? 'Activity' : 'Transactions',
    income: 'Income',
  };
};
